import { createModel } from '@rematch/core';
import type { RootModel } from '.';

export enum Env {
  test = 'test',
  deployTest = 'deploy-test',
  prod = 'prod',
  globalDeployTest = 'global-deploy-test',
  globalProd = 'global-prod'
}

enum HostName {
  test = 'sip.test.xiaopeng.com',
  deployTest = 'sip.deploy-test.xiaopeng.com',
  prod = 'sip.xiaopeng.com',
  globalDeployTest = 'sip-eu.uat.xpeng.com',
  globalProd = 'tis.xpeng.com'
}

export const hostNameToEnvMap: Record<string, string> = {
  [HostName.test]: Env.test,
  [HostName.deployTest]: Env.deployTest,
  [HostName.prod]: Env.prod,
  [HostName.globalDeployTest]: Env.globalDeployTest,
  [HostName.globalProd]: Env.globalProd
};

const initGlobal = {
  env: Env.test
};
const GlobalModel = createModel<RootModel>()({
  state: initGlobal,

  reducers: {
    setEnv(_, action) {
      const { payload } = action;
      return {
        env: payload || ''
      };
    }
  },

  effects: () => ({
    async initEnv() {
      this.setEnv({
        payload: hostNameToEnvMap[window.location.hostname] ?? initGlobal.env
      });
    },
    getGlobalHostName(_, state) {
      const env = state.GlobalModel.env;
      if (env === Env.test) {
        return HostName.test;
      }
      if (env === Env.deployTest || env === Env.globalDeployTest) {
        return HostName.globalDeployTest;
      }
      if (env === Env.prod || env === Env.globalProd) {
        return HostName.globalProd;
      }
      return HostName.test;
    },
    getHostName(_, state) {
      const env = state.GlobalModel.env;
      if (env === Env.test) {
        return HostName.test;
      }
      if (env === Env.deployTest || env === Env.globalDeployTest) {
        return HostName.deployTest;
      }
      if (env === Env.prod || env === Env.globalProd) {
        return HostName.prod;
      }
      return HostName.test;
    }
  })
});

export default GlobalModel;
